var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrossProgression(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 67,
    height: 60,
    viewBox: "0 0 67 60",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_618_900)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_618_900",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 67,
    height: 60
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.4028 0H0V59.4186H66.4028V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_618_900)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.4028 50.0545C66.4028 49.9864 66.3688 49.9183 66.3688 49.8502C66.3347 49.5778 66.3007 49.3054 66.1985 49.067C66.0623 48.7605 65.892 48.5222 65.6877 48.2838C65.6877 48.2838 65.6877 48.2498 65.6537 48.2498C65.4153 48.0114 65.1429 47.8411 64.8364 47.7049C64.53 47.5687 64.1895 47.5006 63.849 47.5006L47.9469 47.5687C47.9469 47.5687 47.9469 47.5687 47.9129 47.5687C45.8698 47.5687 43.8948 46.6153 42.6689 44.9808L38.5146 39.6347C37.6634 38.511 36.0629 38.3067 34.9392 39.1921C33.8155 40.0774 33.6112 41.6438 34.4966 42.7675L38.6509 48.1136C40.8642 50.9739 44.3374 52.6764 47.9469 52.6764H47.981L57.6856 52.6424L55.268 55.06C54.2805 56.0475 54.2805 57.682 55.268 58.6695C55.7787 59.1803 56.4257 59.4186 57.0727 59.4186C57.7197 59.4186 58.3667 59.1803 58.8774 58.6695L65.6877 51.8592C65.9261 51.6209 66.0964 51.3484 66.2326 51.042C66.3347 50.7015 66.4028 50.3609 66.4028 50.0545Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0098 11.6132C18.7964 8.54853 15.2551 6.7438 11.4754 6.7438C11.4413 6.7438 11.4413 6.7438 11.4072 6.7438L2.55386 6.77786C1.15775 6.77786 0 7.93562 0 9.33173C0 10.7278 1.15775 11.8856 2.55386 11.8856L11.4413 11.8515H11.4754C13.6206 11.8515 15.6296 12.8731 16.8555 14.6097L20.533 19.7174C21.0438 20.3984 21.827 20.773 22.6102 20.773C23.121 20.773 23.6658 20.6028 24.1085 20.2963C25.2662 19.445 25.5046 17.8446 24.6873 16.7209L21.0098 11.6132Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.3663 9.5259C66.3663 9.4578 66.4004 9.3897 66.4004 9.35564C66.4004 9.01513 66.3323 8.67462 66.1961 8.36815C66.0599 8.06169 65.8896 7.78928 65.6513 7.55092L58.841 0.74062C57.8535 -0.246873 56.219 -0.246873 55.2315 0.74062C54.244 1.72811 54.244 3.36258 55.2315 4.35008L57.6492 6.76773L48.3531 6.73368C48.3191 6.73368 48.3191 6.73368 48.285 6.73368C44.3691 6.73368 40.6915 8.67461 38.5122 11.9776L16.7533 44.5988C15.5275 46.4375 13.4503 47.5612 11.237 47.5612H11.2029L2.55386 47.4931C1.15775 47.4931 0 48.6168 0 50.047C0 51.4431 1.1237 52.6009 2.55386 52.6009L11.237 52.6349H11.3051C15.2551 52.6349 18.8986 50.6943 21.0779 47.3913L42.8368 14.7698C44.0626 12.9311 46.1398 11.8074 48.3531 11.8074H48.3872L63.8465 11.8755C64.187 11.8755 64.4935 11.8074 64.834 11.6711C65.1405 11.5349 65.4129 11.3647 65.6513 11.1263C65.6513 11.1263 65.6513 11.0923 65.6853 11.0923C65.8896 10.8539 66.0939 10.6156 66.1961 10.3091C66.2982 10.0707 66.3323 9.79831 66.3663 9.5259Z",
    fill: "#CC0000"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_618_900"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 67,
    height: 60,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossProgression);
export default __webpack_public_path__ + "static/media/cross-progression.613ee0fd27e29baeb5a8899b5b872ed5.svg";
export { ForwardRef as ReactComponent };